export enum RouteId
{
	root = 1,
	home,
	documents,
	orders,
	ordersOverview,
	orderDetail,
	deliveries,
	deliveriesOverview,
	deliveryDetail,
	products,
	productsOverview,
	productDetail,
	invoices,
	invoicesOverview,
	invoiceDetail,
	library,
	libraryDocumentsOveriew
}